import React, {Component} from 'react'
import server from '../../server'
import CepInput from '../../inputs/CepInput';
import PressureInput from '../../inputs/PressureInput';

class Record extends Component{
    state = {
        page: 0,
    }

    save = () =>{
        fetch(server.address + "/records",{
            method:"POST",
            headers:{
                'Accept': 'application/json',
                'Content-Type':'application/json'
            },
            body: JSON.stringify(this.props.data)
        }).then(response => response.json().then(data =>{
            if(response.status == 200 || response.status == 201)
                this.props.alert("Sucesso!","Informações atualizadas com sucesso.","success");
            else
                this.props.alert("Erro...","Tente novamente mais tarde","error")
        }))
    }

    render(){
        let imc = 0
        if(this.props.data.weight && this.props.data.height){
            imc = this.props.data.weight /((this.props.data.height/100) ** 2);
        }
        imc = Math.round(imc * 10) / 10;

        return(
            <div class="form-group col-md-12">
                <div class="mB-30 mT-30 clic form-row patient-records">
                    <h4 class="m-0 mB-10">Ficha do paciente</h4>
                    {this.props.page == 0 ?
                        <div>
                            <div class="form-group col-xs-12">
                                <label>Queixa principal</label>
                                <textarea value={this.props.data.complaint} id="complaint" onChange={this.props.onChange}  class="form-control" rows="5" name="toDoctor" placeholder="Queixa principal" />
                            </div>
                            <div class="form-group col-md-12">
                                <label for="inputDiagnostico">Diagnóstico</label>
                                <input value={this.props.data.diagnose} id="diagnose" onChange={this.props.onChange} class="form-control" placeholder="Diagnóstico" type="text"/>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="inputPressao">Pressão arterial (PA):</label>
                                <PressureInput value={this.props.data.pa} id="pa" onChange={this.props.onChange} class="form-control" placeholder="Pressao arterial (PA)" type="text"/>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="inputPressao">Frequência cardiaca (FC):</label>
                                <input value={this.props.data.fc} id="fc" onChange={this.props.onChange} class="form-control" placeholder="Frequencia cardiaca (FC)" type="number" min="60" max="120"/>
                            </div>
                            <div class="form-group col-md-4">
                                <label style={{whiteSpace:"nowrap"}} for="inputPressao">Frequência respiratória (FR):</label>
                                <input value={this.props.data.fr} id="fr" onChange={this.props.onChange} class="form-control" placeholder="Frequencia respiratória (FR)" type="text"/>
                            </div>
                            <div class="form-group col-xs-12">
                                <label>História da Doença Atual</label>
                                <textarea value={this.props.data.actual_disease_history} id="actual_disease_history" onChange={this.props.onChange} class="form-control" rows="5" name="toDoctor" placeholder="Histórico de doença" />
                            </div>
                            <div class="form-group col-xs-12">
                                <label>Patologias pregressas</label>
                                <textarea value={this.props.data.medical_records} id="medical_records" onChange={this.props.onChange} class="form-control" rows="5" name="toDoctor" placeholder="Patologias pregressas" />
                            </div>
                        </div>
                        : <div></div>}

                    {this.props.page == 1 ?<div class="form-group pX-10 mB-10 col-sm-12 w-100p">
                    <div>
                        <div class="p-0 w-100p">
                            <label>HAS</label>
                        </div>
                        <div class="radio radio-client-default">
                            <input onClick={()=>this.props.onChange({target:{id:"has",value:true}})} checked={this.props.data.has} type="radio" name="has-e" id="radio-1" value="sim"/>
                            <label for="radio-1">Sim</label>
                        </div>
                        <div class="radio radio-client-default">
                            <input onClick={()=>this.props.onChange({target:{id:"has",value:false}})} checked={!this.props.data.has} type="radio" name="has-d" id="radio-2" value="nao"/>
                            <label for="radio-2">Não</label>
                        </div>
                    </div>

                    <div class="form-group pX-10 mB-10 col-sm-12 w-100p">
                        <div class="p-0 w-100p">
                            <label>Diabetes</label>
                        </div>
                        <div class="radio radio-client-default">
                            <input onClick={()=>this.props.onChange({target:{id:"diabetes",value:true}})} checked={this.props.data.diabetes} type="radio" name="diabetes-e" id="radio-3" value="sim"/>
                            <label for="radio-3">Sim</label>
                        </div>
                        <div class="radio radio-client-default">
                            <input onClick={()=>this.props.onChange({target:{id:"diabetes",value:false}})} checked={!this.props.data.diabetes} type="radio" name="diabetes-d" id="radio-4" value="nao"/>
                            <label for="radio-4">Não</label>
                        </div>
                    </div>

                    <div class="form-group col-xs-12">
                        <label>Histórico Familiar</label>
                        <textarea value={this.props.data.family_medical_records} id="family_medical_records" onChange={this.props.onChange} class="form-control" rows="5" name="toDoctor" placeholder=" Historico doença familiar" />
                    </div>

                    <div class="form-group col-xs-12">
                        <label>Medicamentos Atuais</label>
                        <textarea value={this.props.data.current_medicines} id="current_medicines" onChange={this.props.onChange} class="form-control" rows="5" name="toDoctor" placeholder=" Medicamentos Atuais" />
                    </div>

                    <div class="form-group col-xs-12">
                        <label>Cirurgias</label>
                        <textarea value={this.props.data.surgeries} id="surgeries" onChange={this.props.onChange} class="form-control" rows="5" name="toDoctor" placeholder="Cirurgias" />
                    </div>

                    <div class="form-group col-xs-12">
                        <label>Atividade Física</label>
                        <textarea value={this.props.data.activities} id="activities" onChange={this.props.onChange} class="form-control" rows="5" name="toDoctor" placeholder="Atividades" />
                    </div>
                    </div>
                    : <div></div>}
                    {this.props.page == 2?
                    <div>
                        <div class="form-group col-md-4">
                            <label for="inputPressao">Altura (cm)</label>
                            <input value={this.props.data.height} id="height" onChange={this.props.onChange} class="form-control" placeholder="Altura" type="text"/>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="inputPressao">Peso (kg)</label>
                            <input value={this.props.data.weight} id="weight" onChange={this.props.onChange} class="form-control" placeholder="Peso" type="text"/>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="inputPressao">IMC:</label>
                            <input value={imc} disabled class="form-control" placeholder="IMC" type="number"/>
                        </div>

                        <div class="form-group col-md-12">
                            <label for="inputPressao">Dor</label>
                            <input value={this.props.data.pain} id="pain" onChange={this.props.onChange} class="form-control" placeholder="Dor" type="text"/>
                        </div>
                        <div class="form-group col-md-12">
                            <label for="inputPressao">Dermátomos</label>
                            <input value={this.props.data.dermatomes} id="dermatomes" onChange={this.props.onChange} class="form-control" placeholder="Dermatomas" type="text"/>
                        </div>
                        <div class="form-group col-md-12">
                            <label for="inputPressao">Palpação:</label>
                            <input value={this.props.data.palpation} id="palpation" onChange={this.props.onChange} class="form-control" placeholder="Palpação" type="text"/>
                        </div>
                        <div class="form-group col-md-12">
                            <label for="inputPressao">Goniometria:</label>
                            <input value={this.props.data.goniometry} id="goniometry" onChange={this.props.onChange} class="form-control" placeholder="Goniometria" type="text"/>
                        </div>
                        <div class="form-group col-md-12">
                            <label for="inputPressao">Força Muscular:</label>
                            <input value={this.props.data.muscular_force} id="muscular_force" onChange={this.props.onChange} class="form-control" placeholder="Força muscular" type="text"/>
                        </div>
                        <div class="form-group col-md-12">
                            <label for="inputPressao">Marcha:</label>
                            <input value={this.props.data.spot} id="spot" onChange={this.props.onChange} class="form-control" placeholder="Força muscular" type="text"/>
                        </div>
                    </div>
                    : <div></div>}

                    {this.props.page == 3?
                    <div>
                        <div class="form-group col-xs-12">
                            <label>Outras Informações</label>
                            <textarea value={this.props.data.other_informations} id="other_informations" onChange={this.props.onChange} class="form-control" rows="5" name="toDoctor" placeholder="Outras informacoes" />
                        </div>
                        <div class="form-group col-xs-12">
                            <label>Diagnóstico funcional</label>
                            <textarea value={this.props.data.functional_diagnostic} id="functional_diagnostic" onChange={this.props.onChange} class="form-control" rows="5" name="toDoctor" placeholder="Diagnostico funcional" />
                        </div>
                        <div class="clearfix"></div>
                        <div class="form-group ta-c col-md-12">
                            <button onClick={this.save} class="btn btn-success" type="button">Salvar alteração</button>
                        </div>
                    </div>
                    :<div></div>}
                    {/*<div class="form-group col-xs-12">
                        <h3>Evolução</h3>
                        <textarea id="evolution" onChange={this.props.onChange} class="form-control" rows="5" name="toDoctor" placeholder="Patologias pregressas" />
                    </div>*/}
                </div>
            </div>
        )
    }
}

class AppointmentBox extends Component{
    state = {
        doctorName:"Carregando..."
    }
    componentWillMount(){
        this.getDoctorName();
    }

    getDoctorName = () =>{
        server.get("appointments/batchs/" + this.props.data.batchId, (data) =>{
            if (data.doctorId) return server.get("users/" + data.doctorId, (data) =>{
                this.setState({doctorName:data.name});
            })

            else return this.setState({doctorName:"Nenhum"})
        });
    }

    render(){
        const status = this.props.data.status == 0 ? 0 : 1;
        const background = status == 0 ? "bgc-client-default" : "bgc-grey-200";
        const textColor = status == 0 ? "c-client-default-inverse" : "c-client-secondary";
        return(
            <div class="w-33p ai-c cur-p pY-10 pX-5">
                <div class=" bd bdrs-2">
                    <div class="bgc-grey-100 bdB pB-5">
                        <div class={"w-100p ta-c bdrsT-2 pY-5 mB-5 " + background}>
                            <div class={"fsz-xs " + textColor}>Atendimento</div>
                            <h4 class={"m-0 " + textColor}>{this.props.id}</h4>
                        </div>
                        <div class="ta-c">
                            <span class="fsz-xs">{server.fullDateString(this.props.data.date.split(" ")[0])}</span>
                            <span class="fsz-sm">
                                <i class="fa fa-clock-o mL-5 c-client-default"></i>{this.props.data.date.split(" ")[1]}
                            </span>
                        </div>
                    </div>
                    <div class="ta-l p-10">
                        <span class="fsz-xs c-client-secondary">Médico</span>
                        <h5 class="mB-10 mT-0">{this.state.doctorName}</h5>
                        { this.props.data.status != 0 ?
                        <div>
                            <span class="fsz-xs c-client-secondary">Comentário Interno</span>
                            <h5 class="mB-10 mT-0">{this.props.data.internalCommentary ? this.props.data.internalCommentary : "Nenhum"}</h5>
                        </div>
                        : <div></div>}
                        {this.props.data.charged ? <span class="badge badge-pill fsz-xs bgc-green-500 c-white">Pago</span> : <div></div>}
                    </div>
                </div>
            </div>
        )
    }
}

class Appointments extends Component{
    state = {
        doctorName: null,
        currentId: -1,
        pictures:[]
    }

    componentDidMount(){
        this.getMedic();
        this.loadAllMedia();
    }

    getMedic = () =>{
        if(this.state.doctorName == null){
            let id = this.props.appointments[this.props.appointments.length - 1].doctorId;
            let that = this;

            if(id == null) return this.setState({doctorName:"Nenhum"});
            else
                server.get("users/" + id, (data) =>{
                    that.setState({doctorName: data.name});
                });
            }
    }

    loadAllMedia = () =>{
        if(this.state.pictures.length == 0)
            this.props.data.appointments.forEach(app =>{
                console.log(app)
                server.getMedia(app.id, this);
            })
    }

    createBoxes = () =>{
        let boxes = [];
        let appointments = this.props.data.appointments;

        for(let app in appointments){
            boxes.push(<AppointmentBox id={parseInt(app) + 1} data={appointments[app]}/>)
        }
        
        return boxes;
    }

    render(){
        const boxes = this.createBoxes().reverse();

        return(
            <div class="form-group col-md-12 ">
                <div class="inner-content mobile-scroll__inner">
                    <div>
                        <div class="p-10 peers ai-c jc-sb  w-100p  h-100p">
                            <div class="w-100p pX-10 pY-5 ai-c">
                                <div class="fsz-xs c-client-default">Médico atual</div>
                                <h3 class="m-0">{this.state.doctorName}</h3>
                            </div>
                            <div class="w-100p pX-10 pY-5 ai-c">
                                <div class="fsz-xs c-client-default">Fotos e vídeos</div>
                                <div class="client-midias mT-5">
                                    {this.state.pictures}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-10 client-attendance bdT">
                        <div class="ta-c">
                            <h4 class="m-0 ta-c">Atendimentos</h4>
                            {/*<span class="fsz-xs c-client-default">Clique para atender</span>*/}
                        </div>
                        <div class="attendances peers">
                            {boxes}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

class PersonalDetails extends Component{
    state = {
        sending:false
    }

    sendData = (data, picture) =>{

        if(picture) data["profilePicture"] = picture.target.result.split(",")[1];

        server.put("users/" + data.id, data, (data) =>{
            if(data)
                this.props.alert("Sucesso!","Informações atualizadas com sucesso.","success");
            else
                this.props.alert("Erro...","Tente novamente mais tarde","error");

            this.setState({sending:false});
            this.props.close();
        });
    }

    save = () =>{
        if(this.state.sending) return this.props.alert("Aguarde!","Estamos salvando suas alterações!","warning");;

        this.setState({sending:true});
        let data = {};

        Object.assign(data, this.props.data);

        if(data["cep"] && data["cep"].replace)
            data["cep"] = data["cep"].replace("-","");

        var fileReader = new FileReader( );

        fileReader.onload = (picture) => this.sendData(data, picture);
        if(data.image != null)
            fileReader.readAsDataURL(data.image);
        else
            this.sendData(data, null);
    }

    updateFile = (event) =>{
        this.props.onChange({target:{id:"image", value:event.target.files[0]}})
    }

    render(){
        return(
            <div style={{width:"100%"}} class="form-group col-md-6 m-0 p-0">
                <div class="col-md-12 mT-20">
                    <div class="pB-0 peers jc-c ai-c bdB mB-10 pB-20">
                        <img class="w-10r bdrs-50p user-image bdc-client-default" src={server.imagePath + "/profile/" + this.props.data.profilePicture} alt=""/>
                        <div class="mL-20">
                            <h4 class="m-0">
                                <b>{this.props.data.name}</b>
                            </h4>
                            <p class="m-0 c-client-secondary">
                                <i class="fa fa-envelope  c-client-default"></i>{this.props.data.email}</p>
                            <p class="m-0  c-client-secondary">
                                <i class="fa fa-phone  c-client-default"></i>{this.props.data.telephone}</p>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="clearfix"></div>
                        <div class="mB-30 mT-30 clic form-row clinic-edit-form">
                        {this.props.page == 0 ?
                        <div>
                            <h4 class="m-0 mB-10">Foto do paciente</h4>
                            <div class="form-group col-xs-12">
                                <input onChange={this.updateFile} id="profilePicture" type="file"/>    
                            </div>
                            <h4 class="m-0 mB-10">Dados do paciente</h4>
                            <div class="form-group col-xs-12">
                                <label for="inputName">Nome</label>
                                <input value={this.props.data.name} id="name" class="form-control" name="inputName" disabled placeholder="Nome" type="text"/>
                            </div>
                            <div class="form-group col-xs-6">
                                <label for="inputDocument">CPF:</label>
                                <input value={this.props.data.cpf} id="cpf" class="form-control" name="inputDocument" disabled placeholder="CPF" type="text"/>
                            </div>
                            <div class="form-group col-xs-6">
                                <label for="inputEmail">E-mail</label>
                                <input disabled value={this.props.data.email} id="email" class="form-control" name="inputEmail" placeholder="E-mail" required="" type="text"/>
                            </div>
                            <div class="form-group col-xs-6">
                                <label for="inputDate">Data Nascimento</label>
                                <input onChange={this.props.onChange} value={this.props.data.birthDate} id="birthDate" class="form-control" name="inputDate" type="date"/>
                            </div>
                            <div class="form-group col-xs-6">
                                    <label for="inputPhone">Telefone</label>
                                    <input onChange={this.props.onChange} value={this.props.data.telephone} id="telephone" class="form-control" name="inputPhone" placeholder="Telefone" required="" type="text"/>
                                </div>
                            <div class="form-group col-xs-12">
                                <label for="inputOccupation">Profissão:</label>
                                <input onChange={this.props.onChange} value={this.props.data.profession != null ? this.props.data.profession : ""} id="profession" class="form-control" name="inputUccupation" placeholder="Profissão" type="text"/>
                            </div>
                            <div class="form-group col-xs-12">
                                <div class="p-0 w-100p">
                                    <label>Estado civil</label>
                                </div>
                                <div onClick={()=>this.props.onChange({target:{id:"civilState",value:0}})} class="radio radio-client-default">
                                    <input checked={this.props.data.civilState == 0}  type="radio" name="estado" id="radio-1" value="Solteiro"/>
                                    <label for="radio-1">Solteiro</label>
                                </div>
                                <div onClick={()=>this.props.onChange({target:{id:"civilState",value:1}})} class="radio radio-client-default">
                                    <input checked={this.props.data.civilState == 1} type="radio" name="estado" id="radio-2" value="Casado"/>
                                    <label for="radio-2">Casado</label>
                                </div>
                                <div onClick={()=>this.props.onChange({target:{id:"civilState",value:2}})} class="radio radio-client-default">
                                    <input checked={this.props.data.civilState == 2} type="radio" name="estado" id="radio-3" value="Divorciado"/>
                                    <label for="radio-3">Divorciado</label>
                                </div>
                                <div onClick={()=>this.props.onChange({target:{id:"civilState",value:3}})} class="radio radio-client-default">
                                    <input checked={this.props.data.civilState == 3} type="radio" name="estado" id="radio-4" value="Outro"/>
                                    <label for="radio-4">Viúvo</label>
                                </div>
                                <div onClick={()=>this.props.onChange({target:{id:"civilState",value:4}})} class="radio radio-client-default">
                                    <input checked={this.props.data.civilState == 4} type="radio" name="estado" id="radio-4" value="Outro"/>
                                    <label for="radio-4">Outro</label>
                                </div>
                            </div>
                        </div>
                        : <div></div>}

                            {this.props.page == 1 ?
                            <div>
                                <div class="form-group col-md-12">
                                    <label>CEP:</label>
                                    <CepInput onChange={this.props.onChange} value={this.props.data.cep ? this.props.data.cep : ""} id="cep" class="form-control" name="inputCep" placeholder="CEP" type="text"/>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputStreet">Endereço</label>
                                    <input onChange={this.props.onChange} value={this.props.data.street != null ? this.props.data.street : ""} id="street" class="form-control" name="inputStreet" placeholder="Endereço" required="" type="text"/>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputNumber">Número</label>
                                    <input onChange={this.props.onChange} value={this.props.data.number ? this.props.data.number : ""} id="number" class="form-control" name="inputNumber" placeholder="Numero" required="" type="text"/>
                                </div>

                                <div class="form-group col-md-12">
                                    <label for="inputComplement">Complemento</label>
                                    <input onChange={this.props.onChange} value={this.props.data.complement ? this.props.data.complement : ""} id="complement" class="form-control" name="inputComplement" placeholder="Complemento" required="" type="text"/>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputNeighborhood">Bairro</label>
                                    <input onChange={this.props.onChange} value={this.props.data.neighborhood ? this.props.data.neighborhood : ""} id="neighborhood" class="form-control" name="inputNeighborhood" placeholder="Bairro" required="" type="text"/>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputCity">Cidade</label>
                                    <input onChange={this.props.onChange} value={this.props.data.city ? this.props.data.city : ""} id="city" class="form-control" name="inputCity" placeholder="Cidade" required="" type="text"/>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputState">Estado</label>
                                    <input onChange={this.props.onChange} value={this.props.data.uf ? this.props.data.uf : ""} id="uf" class="form-control" name="inputUF" placeholder="Estado" maxlength="2" required="" type="text"/>
                                </div>
                                <div class="clearfix"></div>
                                <div class="form-group ta-c col-md-12">
                                    <button onClick={this.save} class="btn btn-success" type="button">Salvar alteração</button>
                                </div>
                            </div>
                            : <div></div>}
                        </div>
                    </div>
                </div>
            </div>)
    }
}

class Commentary extends Component{
    state = {
        fisioterapist: {},
        pictures:[],
        approved:false
    }

    componentDidMount(){
        server.getMedia(this.props.data.id, this)
        this.loadFisioterapistName(this.props.data.fisioterapistId);
        this.setState({approved: this.props.data.doctorApproval});
    }

    loadFisioterapistName = (id) =>{
        if(Object.keys(this.state.fisioterapist).length == 0 )
            server.get("users/" + id,(data) =>{
                this.setState({fisioterapist: data})
            });
    }

    approveOpinion = () =>{
        let appData = this.props.data;
        appData["doctorApproval"] = 1;
        server.put("appointments/batchs/" + this.props.data.id, appData, (data) =>{
            this.props.alert("Sucesso!", "A opinião do fisiterapeuta foi aprovada!", "success");
            this.setState({approved: true});
        })
    }

    respondFisioterapist = () =>{
        let data = this.props.data;
        data.response_doctor = this.state.response;

        fetch(server.address + "/appointments/" + this.props.data.id,{
            method:"PUT",
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json'
            },
            body:JSON.stringify(data)
        }).then(response => {
            if(response.status == 200 || response.status == 201)
                this.props.alert("Sucesso!", "Sua resposta foi enviada.", "success");
                this.setState({answered: true});
        })
    }

    render(){
        const opinions = [
            "", "Alta","Necessita mais consultas terapeuticas","Necessita mais consultas médicas"
        ]
        console.log(this.state.approved)
        return(
            <div class="bdB pT-20">
                <div class="w-100p peers jc-sb">
                    <div>
                        <h5 class="m-0"><b>{this.props.data.date}</b></h5>
                        <p class="c-client-secondary fsz-sm">{this.props.data.onClinic == true ? "Clínica" : "Domiciliar"}</p>
                    </div>
                    <div class="peers">
                        <img class="fisio-foto mR-10" src={server.imagePath + "/profile/" + this.state.fisioterapist.profilePicture}
                            alt=""/>
                        <div>
                            <p class="m-0 fsz-xs c-client-default h12">Fisioterapeuta</p>
                            <p class="p-0 m-0">{this.state.fisioterapist.name}</p>
                        </div>
                    </div>
                </div>
                <div class="expand-block expand">
                    <div class="w-100p pX-10 pY-5 ai-c">
                        <div class="fsz-xs c-client-default">Opinião do Fisioterapeuta</div>
                        <p>{opinions[this.props.data.fisioterapistOpinion]}</p>
                        {this.state.approved == null ?
                            <button class="btn btn-client-default"
                                    onClick={this.approveOpinion}
                                    style={{marginBottom: 20, marginTop: -5, fontSize: 10}}>
                                Aprovar
                            </button> :
                            <p>
                                Opinião Aprovada
                            </p>
                        }
                        <div class="fsz-xs c-client-default">Fotos e vídeos</div>
                        <div class="client-midias mT-5">
                            {this.state.pictures}
                        </div>
                    </div>
                        {/*<div style={!this.state.answerEnabled ? {display:"none"} : {}}>
                            <div class="form-group col-xs-12 mT-20">
                                <label for="inputCep">Comentário para o fisioterapeuta</label>
                                <textarea value={this.state.response} onChange={(event) => this.setState({response: event.target.value})} class="form-control" rows="2" name="toDoctor"
                                    placeholder="Algum comentário para o fisioterapeuta?" />
                            </div>
                            <div class="form-group ta-c col-xs-12">
                                <button onClick={this.respondFisioterapist} class="btn btn-client-default" type="button">Atualizar</button>
                            </div>
                        </div>*/}
                </div>
            </div>
        )
    }
}

class AppointmentsCommentary extends Component{
    state={
        commentaries:[]
    }

    componentWillReceiveProps(nextProps){
        this.loadAppointments();
    }

    loadAppointments = () => {
        let commentaries = [];
        if(this.props.appointments)
            this.props.appointments.forEach((app) =>{
                if(app.status != 0)
                    commentaries.push(<Commentary key={app.id} alert={this.props.alert} data={app}/>)
            })
        this.setState({commentaries:commentaries.reverse()});
    }

    render(){
        return(
            <div class="form-group col-xs-12 col-md-6" style={{overflowX:"auto", height:500}}>
                <div class="clearfix"></div>
                <div class="w-100p peers jc-sb">
                    <h4 class="c-client-default">( {this.state.commentaries.length} ) Atendimentos realizados</h4>
                </div>
                {this.state.commentaries}
            </div>
        )
    }
}

class SecreataryPatientDetail extends Component{
    render(){
        const isSecretary = server.userType in ["secretary","doctor"];
        return(
            <div>
                <div class="w-100p ai-c jc-sb b-0 ">
                    <div class="col-md-12 peers jc-sb pL-20 bdB">
                        <h3>Dados do paciente</h3>
                    </div>

                    <button onClick={this.props.onClose} type="button" class="modal-toogle btn btn-clear pX-5 pY-0 pos-a t-15 r-0 bdrs-2 cur-p c-client-secondary">
                        <i class="material-icons">close</i>
                    </button>

                    <div class="clearfix"></div>
                </div>
                <div style={{position: "absolute", width: "100%"}} class="scrollable">
                    <div class="content-data peers  ai-c jc-c">
                        <div class="pacient-data mT-20 row">
                            <div class="form-group col-xs-12 m-0 p-0" style={{width:"100%"}}>
                                <div class="col-md-6">
                                    <div class="pB-0 peers ai-c jc-c bdB mB-10 pB-20">
                                        <div class="pos-r">
                                            <img class="w-10r bdrs-50p user-image bdc-client-default" src={server.imagePath + "/profile/" + this.props.data.profilePicture}
                                                alt=""/>
                                        </div>


                                        <div class="mL-20">
                                            <h4 class="m-0">
                                                <b>{this.props.data.name}</b>
                                            </h4>
                                            <p class="m-0 c-client-secondary">
                                                <i class="fa fa-envelope  c-client-default"></i>
                                                {this.props.data.email}</p>
                                            <p class="m-0  c-client-secondary">
                                                <i class="fa fa-phone  c-client-default"></i>{this.props.data.telephone}</p>

                                            <div class="peers p-10  bgc-grey-100 bd bdrs-4">
                                                <div class="ai-c">
                                                    <div class="fsz-xs c-client-default">{isSecretary ? 'Médico' : 'Fisioterapista'} atual</div>
                                                    <h4 class="p-0 m-0 ">{isSecretary ? this.props.doctorName : this.props.fisioterapistName}</h4>
                                                </div>
                                                <div class="mL-10 ai-c ta-c">
                                                    <div class="fsz-xs c-client-default">Consultas</div>
                                                    <h4 class="m-0">{this.props.data.appointments == null ? 0 : this.props.data.appointments.length}</h4>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-sm-12" style={{margin:"auto", width:"fit-content"}}>
                                        <div class="clearfix"></div>

                                        <div class="clearfix"></div>
                                        <div class="form-group col-xs-6">
                                            <label for="inputName">
                                                <b>CPF</b>
                                            </label>
                                            <p>{this.props.data.cpf}</p>
                                        </div>
                                        <div class="form-group col-xs-6">
                                            <label for="inputName">
                                                <b>Profissão</b>
                                            </label>
                                            <p>{this.props.data.profession == null ? "Nenhuma" : this.props.data.profession}</p>
                                        </div>

                                        <div class="form-group col-sm-12">
                                            <label for="inputName">
                                                <b>E-mail: </b>{this.props.data.email}
                                            </label>
                                        </div>
                                        <div class="form-group col-sm-12">
                                            <p>
                                                <label for="inputName">
                                                    <b>Dt. Nasc: </b>{this.props.data.birthDate}
                                                </label>

                                            </p>
                                        </div>
                                    </div>
                                </div>
                                {this.props.type == "doctor" ?
                                <AppointmentsCommentary alert={this.props.alert} appointments={this.props.data.appointments}/>
                                : <div></div>}
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

class FisioterapistPatientDetail extends Component{
    state = {page:0,subpage:0};

    componentWillReceiveProps(nextProps){
        let nextState ={
            page:0,
            subpage:0
        };

        this.setState(nextState);

        this.setState(nextState,() => {
            if(nextProps.data){
                server.get('users/' + nextProps.data.id + '/record',data =>{
                    
                    if(data.id) this.setState({record:data})
                    else this.setState({record:{patient_id:nextProps.data.id}})
                });

                nextState.street = "";
                nextState.neighbourhood = ""; 
                nextState.state = ""; 
                nextState.city = "";

                Object.keys(nextProps.data).forEach((key) =>{
                    if(key == null)
                        nextState[key] = "";
                    else
                        nextState[key] = nextProps.data[key];
                })
                this.setState(nextState);
            }
        });
    }

    nextSubPage(){

    }

    changeState = (event) =>{
        this.setState({[event.target.id]:event.target.value})
    }

    changeRecordState = (event) =>{
        let record = this.state.record;
        console.log(event)
        record[event.target.id] = event.target.value;
        this.setState({record:record})
    }

    loadCEP = (cep) =>{
        if(cep && typeof(cep) == "string"){
            let cepNumber = cep.replace(/\-/,"").replace(/\_/,"")
            if(cepNumber.length == 8){
                if(!this.state.cep_loaded){
                        fetch(server.address + "/cep/" + cepNumber,{
                                method: "GET"
                        }).then(response => response.json().then(data => {
                                this.setState({street:data.endereco,neighborhood:data.bairro,uf:data.uf,city:data.cidade})
                        }))
                        this.setState({cep_loaded:true})
                }
            }else{
                if(this.state.cep_loaded){
                        this.setState({cep_loaded:false})
                }
            }
        }
    }

    render(){
        this.loadCEP(this.state.cep);

        const pages = [
            <PersonalDetails close={this.props.onClose} refresh={this.props.refresh} alert={this.props.alert} data={this.state} onChange={this.changeState} page={this.state.subpage}/>,
            <Record page={this.state.subpage} alert={this.props.alert} data={this.state.record} onChange={this.changeRecordState}/>,
            <Appointments data={this.state} appointments={this.state.appointments}/>
        ]

        const subpagesName = [
            ["Dados Pessoais",
               "Endereço",],
            ["Parte 1/4",
               "Parte 2/4",
               "Parte 3/4",
               "Parte 4/4"],
               []
        ]

        const subPageStatusClass = "step-number mR-5 p-5 c-client-default-inverse";
        return(
            <div>
                <div class="w-100p ai-c jc-sb b-0">
                    <div class="peers jc-c w-100p bgc-white bdB">
                        <div class="stv-radio-buttons-wrapper peers jc-c pY-10 ">
                            <input onClick={()=>this.setState({page:0,subpage:0})} type="radio" class="stv-radio-button" name="tab" value="1" id="personalData" checked={this.state.page == 0} />
                            <label for="personalData" class="fsz-sm">Dados pessoais</label>
                            <input onClick={()=>this.setState({page:1,subpage:0})} type="radio" class="stv-radio-button" name="tab" value="2" id="address" checked={this.state.page == 1} />
                            <label for="address" class="fsz-sm">Ficha</label>
                            <input onClick={()=>this.setState({page:2,subpage:0})} type="radio" class="stv-radio-button" name="tab" value="3" id="mySchedules" checked={this.state.page == 2} />
                            <label for="mySchedules" class="fsz-sm">Atendimento</label>
                        </div>
                        <button onClick={this.props.onClose} type="button" class="modal-toogle btn btn-clear pX-5 pY-0 pos-a t-10 r-0 bdrs-2 cur-p c-client-secondary">
                            <i style={{fontSize:20}} class="fa fa-close"></i>
                        </button>
                    </div>

                    {this.state.page == 0 ?
                        <div class="col-md-12 peers jc-c pY-20 bdB">
                            <div class="peers ai-c mX-5">
                                <span class={this.state.subpage == 0 ? subPageStatusClass + " bgc-client-default" : subPageStatusClass + " bgc-client-secondary"}>1</span>
                                <span class={this.state.subpage == 0 ? "c-client-default" + " step-text" : "c-client-secondary" + " step-text"}>
                                    <b>Dados pessoais</b>
                                </span>
                            </div>
                            <div class="peers ai-c mX-5">
                                <span class={this.state.subpage == 1 ? subPageStatusClass + " bgc-client-default" : subPageStatusClass + " bgc-client-secondary"}>2</span>
                                <span class={this.state.subpage == 1 ? "step-text" + " c-client-default" : "step-text" + " c-client-secondary"}>Endereço</span>
                            </div>

                        </div> : <div></div>
                    }
                    <div class="clearfix"></div>
                </div>
                <div style={{paddingBottom: 200, position:"absolute", width:"100%"}} class="scrollable">
                    {pages[this.state.page]}
                </div>
                {this.state.page != 2 && this.props.open === 0 ?
                <div style={{position:"fixed",bottom:0,width:"100%"}} class="bdT p-10 peers jc-sb ai-c bgc-client-default">
                    <div class="peers ai-c">
                        <span class="step-number bgc-pink-500 c-white mL-10">1</span>
                        <div class="mL-10">
                            <h4 class="m-0 c-client-default-inverse fsz-sm">{subpagesName[this.state.page][this.state.subpage]}</h4>
                        </div>

                    </div>

                    <button style={{position: "fixed",right: 10}} onClick={() => this.setState({subpage: (this.state.subpage + 1)%subpagesName[this.state.page].length})} class="btn btn-clear peers ai-c pX-5 pY-0 bdrs-2 mR-3 cur-p c-client-default-inverse fsz-md" type="button">
                        {subpagesName[this.state.page][(this.state.subpage + 1)%(subpagesName[this.state.page].length)]}
                        <i class="fa fa-angle-right fsz-xl"></i>
                    </button>
                </div> : <div></div>
                }
        </div>
        )
    }
}

class PatientDetail extends Component{
    state={
        doctorName:"Nenhum"
    }

    componentWillReceiveProps(prop){
        console.log(prop)
        if(prop.data){
            this.loadDoctor(prop.data.appointments[prop.data.appointments.length - 1].doctorId);
            this.loadFisioterapists(prop.data.appointments[prop.data.appointments.length - 1].fisioterapistId);
        }
    }

    loadDoctor = (id) =>{
        if (id == null)
            return;

        let that = this;

        server.get("users/" + id, (data) =>{
            that.setState({doctorName: data.name})
        })
    }

    loadFisioterapists = (id) =>{
        if (id == null)
            return;

        let that = this;

        server.get("users/" + id, (data) =>{
            that.setState({fisioterapistName: data.name})
        })
    }

    render(){
        const data = this.props.data == null ? {} : this.props.data;
        const component = server.userType == "fisioterapist" ? <FisioterapistPatientDetail open={this.props.open} alert={this.props.alert} data={this.props.data} onClose={this.props.onClose}/> : <SecreataryPatientDetail doctorName={this.state.doctorName} fisioterapistName={this.state.fisioterapistName} alert={this.props.alert} type={server.userType} data={data} onClose={this.props.onClose}/>
        return(
            <div style={{"top":(this.props.open * 100) + "%"}} class="app-modal bgc-white mobile-scroll ">
                <div class="w-100p clinic-data ">
                    {component}
                </div>
            </div>
        )
    }
}

export default PatientDetail



// WEBPACK FOOTER //
// ./src/pages/patients/PatientDetail.js